import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { BestBuyItemPricesFragmentDoc } from './BestBuyItemPrices.generated'
import { TileProductInfoProductFragmentDoc } from './TileProductInfoProduct.generated'
import * as Types from './purchasePlus_graphql'

export const QuotesModalTileViewPricesFragmentDoc = gql`
  fragment QuotesModalTileViewPrices on Price {
    uuid
    unitPrice
    taxPercentage
    supplierManaged
    pricedCataloguedProduct {
      id
    }
    supplier {
      id
      name
      supplierRelationship {
        id
      }
    }
    catalogue {
      id
      title
    }
    product {
      id
      productCode
      ...TileProductInfoProduct
    }
    contracted
    ...BestBuyItemPrices
  }
  ${TileProductInfoProductFragmentDoc}
  ${BestBuyItemPricesFragmentDoc}
` as unknown as DocumentNode<Types.QuotesModalTileViewPricesFragment, unknown>
